__turbopack_context__.v({
  "categories": "Error404Message-module-scss-module__ftuvJG__categories",
  "container": "Error404Message-module-scss-module__ftuvJG__container",
  "wrapper": "Error404Message-module-scss-module__ftuvJG__wrapper",
});
